import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import AppTest from './App.test';
import * as serviceWorker from './serviceWorker';
import store from './redux/store';
import { Provider } from 'react-redux';
import "../src/assets/css/mobile-responsive-only.scss";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js'; 

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
      {/* <AppTest /> */}
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
